module.exports = __webpack_public_path__ + "img/img21.4dc4d203.svg";